// A per-page-load id for the current app session. Clarity generates its own session id, but it is
// not readable from our side, so we mint one we can also surface elsewhere (debug panel, support
// tickets) to line a merchant complaint up with a recording. Deliberately not persisted - every
// full page load starts a new session id.
let sessionId: string | undefined;

const generateSessionId = (): string => {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
        return crypto.randomUUID();
    }

    // non-secure contexts (plain http dev hosts) have no randomUUID
    return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
};

const getSessionId = (): string => {
    if (!sessionId) {
        sessionId = generateSessionId();
    }

    return sessionId;
};

export default { getSessionId };
